import AppFilePreview from './AppFilePreview';

export default AppFilePreview;